import axios from "axios";
import Vue from "vue";
import QS from "qs";

axios.defaults.baseURL =
  Vue.prototype.BASE_API === undefined
    ? "http://localhost:53212"
    : Vue.prototype.BASE_API;
axios.defaults.timeout = 100000;

// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    let token = "";
    config.headers = {
      "access-token": token,
      "Content-Type": "application/json;charset=UTF-8",
    };
    // 在发送请求之前做些什么
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    // 在接收响应做些什么，例如跳转到登录页
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url,params)
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
// export function fetchPost(url, params) {
//   return new Promise((resolve, reject) => {
//     axios
//       .post(url, QS.stringify(params))
//       .then(
//         (response) => {
//           resolve(response);
//         },
//         (err) => {
//           reject(err);
//         }
//       )
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }

//返回一个Promise(发送get请求)
export function fetchGet(url, param) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: param })
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
export default {
  fetchGet,
  fetchPost,
};
